export default "__VITE_ASSET__uPol8eV___";